export default {
  quoteText: "If music be the food of love, play on;",
  quoteBy: "William Shakespeare"
};
